import "core-js/es6/map";
import "core-js/es6/set";

import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./web_modules/App";

declare global {
  interface Window {
    eaveEnv: EaveEnv;
    missingEnvVars: string[];
    analytics: SegmentAnalytics.AnalyticsJS;
  }
}

interface EaveEnv {
  apps: {
    borrower: string;
    operator: string;
    marketing: string;
  };
  env: string;
  pusher: PusherEnv;
  featureFlags: {
    sofrConforming: string;
    sofrJumbo: string;
  };
}

interface PusherEnv {
  key: string;
}

ReactDOM.render(<App />, document.getElementById("react"));

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept("./web_modules/App", () => {
    const NextApp = require<{ default: typeof App }>("./web_modules/App").default;
    ReactDOM.render(<App />, document.getElementById("react"));
  });
}
